import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../../../stores/NavigateStore";


export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        height: 'calc(100vh - 350px)'
    },
    tabBox: {
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
            }
        }
    },
    buttonStyle: {
        display: 'flex',
        justifyContent: 'right',
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
            }
        }
    },
    sentenceTextBox: {
        border: '1px solid #87888d',
        borderRadius: 8,
        height: 110,
        '&.MuiBox-root': {
            padding: 13,
            marginTop: 20,
        },
        '& .MuiTypography-root': {
            color: '#000',
            letterSpacing: '-0.2px',
            '& span': {
                background: 'rgba(242, 124, 87, 0.7)'
            }
        }
    },
    fixTextBox: {
        '& .MuiTypography-root': {
            '& span': {
                color: '#000',
                fontSize: '1rem',
                fontWeight: 500,
                background: '#fff',
                borderRadius: 5,
                border: '1px solid #87888d',
                padding: '2px 5px',
                margin: '0px 3px',
            }
        }
    },
    uncomplete: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
            }
        }
    },
    complete: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
            }
        }
    },
    fixUncomplete: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
            }
        }
    },
    fixComplete: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
            }
        }
    },





    progressBarBox: {
      width: 400,
        '& .MuiBox-root': {
            padding: 0,
            marginBottom: 8,
            display: 'flex',
            justifyContent: 'flex-end',
        },
        '& .MuiButtonBase-root': {
            padding: 0,
        }
    },
    uploadData: {
        '&.MuiBox-root': {
            display: 'flex',
            justifyContent: 'flex-start',
            '& .MuiTypography-root': {
                color: '#87888d',
                fontSize: '0.813rem',
                letterSpacing: '-0.5px',
            }
        }
    },
    progressBar: {
        '&.MuiLinearProgress-root': {
            height: 20,
            width: 400,
            borderRadius: '25px',
        },
        '& .MuiLinearProgress-barColorPrimary': {
            background: '#5579f0',
            borderRadius: '25px',
        },
        '&.MuiLinearProgress-colorPrimary': {
            background: '#d7d7d7',
        }
    },
    barState: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiTypography-root': {
            marginTop: 5,
            color: '#5579f0',
            fontSize: '0.875rem',
            letterSpacing: '-0.5px',
        }
    },
    uploadText: {
        textAlign: 'center',
        fontSize: '1.063rem',
        color: '#10121c',
        letterSpacing: '-0.5px',
        marginTop: 40,
    },
    popoverTooltip: {
        '& .MuiPopover-paper': {
            background: '#365edf',
            color: '#fff',
            minWidth: 343,
            minHeight: 90,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginTop: 15,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    tooltipTop: {
        position: 'absolute',
        top: -10,
        left: '50%',
        color: '#000'
    },
    tooltipBtn: {
        marginBottom: 5,
        '& .MuiButtonBase-root': {
            padding: 0,
            minWidth: 'auto',
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    textField: {
        marginTop: 10,
        height: 110,
        border: '1px solid #87888d',
        borderRadius: 8,
        '& .MuiOutlinedInput-multiline': {
            padding: 13
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 0
        }
    }


}));













// 추후 삭제 예정 개발 페이지에서 작업하실때는 안가져 가셔도 됩니다.
    // listButtonStyle: {
    //     '& .MuiButtonBase-root': {
    //         '&:hover': {
    //             background: 'transparent'
    //         },
    //     },
    //     '& .MuiTypography-root': {
    //         marginLeft: 5,
    //         fontSize: '1rem',
    //         fontWeight: 'bold',
    //         letterSpacing: '-0.62px',
    //         color: '#10121c',
    //     }
    // },
    // buttonStyle2Active: {
    //     '& .MuiButtonBase-root': {
    //         border: '1px solid #5579f0',
    //         borderRadius: 4,
    //         background: '#fff',
    //         width: 100,
    //         height: 48,
    //         '& .MuiTypography-root': {
    //             fontSize: '1.125rem',
    //             fontWeight: 'bold',
    //             letterSpacing: '-0.51px',
    //             color: '#5579f0'
    //         }
    //     }
    // },
    // buttonStyle2: {
    //     '& .MuiButtonBase-root': {
    //         border: '1px solid #bcbcbc',
    //         borderRadius: 4,
    //         background: '#fff',
    //         width: 100,
    //         height: 48,
    //         '& .MuiTypography-root': {
    //             fontSize: '1.125rem',
    //             fontWeight: 'bold',
    //             letterSpacing: '-0.51px',
    //             color: '#bcbcbc'
    //         }
    //     }
    // },
    // buttonStyle3: {
    //     '& .MuiButtonBase-root': {
    //         border: '0px solid #5579f0',
    //         background: 'rgba(16, 18, 28, 0.3)',
    //         marginLeft: 16,
    //         width: 100,
    //         height: 48,
    //         '& .MuiTypography-root': {
    //             fontSize: '1.125rem',
    //             fontWeight: 'bold',
    //             letterSpacing: '-0.51px',
    //             color: '#fff'
    //         }
    //     }
    // },
    // buttonStyle3Active: {
    //     '& .MuiButtonBase-root': {
    //         border: '0px solid #5579f0',
    //         background: '#5579f0',
    //         '& .MuiTypography-root': {
    //             fontSize: '1.125rem',
    //             fontWeight: 'bold',
    //             letterSpacing: '-0.51px',
    //             color: '#fff'
    //         }
    //     }
    // },
    // backButton: {
    //     background: '#fff',
    //     boxShadow: 'none',
    //     padding: 0,
    //     '&:hover': {
    //         background: 'transparent',
    //         boxShadow: 'none',
    //     }
    // },
    // boxWrapTranslation: {
    //     height: 'calc(100vh - 740px)'
    // },
    // boxBottomTranslation: {
    //     backgroundColor: '#fff',
    //     padding: 20,
    //     borderRadius: 8,
    //     marginTop : 20,
    //     '& .MuiFormControl-root': {
    //         width: '100%'
    //     },
    //     '& div:nth-child(1)': {
    //         marginTop: 0,
    //     }
    // },
    // translationTitle: {
    //     marginTop: 33,
    //     marginBottom: 10,
    //     '& .MuiTypography-root': {
    //         fontSize: '0.938rem',
    //         fontWeight: 'bold',
    //         letterSpacing: '-0.5px',
    //         color: '#10121c',
    //         marginRight: 12,
    //     },
    //     '& .MuiButtonBase-root': {
    //         minWidth: 'auto',
    //         padding: 0,
    //     }
    // },
    // switchStyle: {
    // },
    // textQuizBox: {
    //     marginTop: 10,
    //     '& .MuiFormControl-root': {
    //         width: 240,
    //         height: 40,
    //         boxSizing: 'border-box',
    //         marginRight: 10,
    //     },
    //     '& .MuiOutlinedInput-root': {
    //         height: 40
    //     },
    //     '& .MuiButtonBase-root': {
    //         width: 70,
    //         height: 40,
    //         background: 'rgba(16, 18, 28, 0.3)',
    //         '& .MuiTypography-root': {
    //             fontSize: '1.125rem',
    //             color: 'rgba(255, 255, 255, 0.7)',
    //             fontWeight: 'bold'
    //         }
    //     }
    // },
    // active: {
    //     '&.MuiButtonBase-root': {
    //         width: 70,
    //         height: 40,
    //         background: '#f27c57',
    //         '& .MuiTypography-root': {
    //             fontSize: '1.125rem',
    //             color: '#fff',
    //             fontWeight: 'bold'
    //         }
    //     }
    // },
    // quizListBox: {
    //     '& > div': {
    //         width: 600,
    //     },
    //     '& > div:last-child': {
    //         width: 500,
    //     },
    // },
    // quizWord: {
    //     border: '1px solid #87888d',
    //     width: 160,
    //     height: 40,
    //     borderRadius: 4,
    //     '& .MuiTypography-root': {
    //         width: 110,
    //         textAlign: 'center',
    //         fontSize: '1.125rem',
    //         fontWeight: 'bold'
    //     }
    // }
